// Cores padrão:
export const darkColor = "#1e1e1e";
export const darkSecundaryColor = "#242424";
export const greenColor = "#83d84d";
export const lightGreenColor = "#83d84d";
export const whiteColor = "#ffffff";
export const blackColor = "#000000";
